var render = function render() {
  var _vm$pushData, _vm$pushData2;
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    ref: "pushContent",
    staticClass: "push-content",
    class: _vm.warningPushClass
  }, [_vm.visiableForewarningIcon ? _c('div', {
    staticClass: "map-logo"
  }, [_c('div', {
    staticClass: "map-logo-icon"
  })]) : _vm._e(), _vm.push_type ? _c('push-template1', {
    attrs: {
      "push_third_url": _vm.push_third_url,
      "push_third_text": _vm.push_third_text,
      "button_url": _vm.button_url,
      "push_title": _vm.contentData && _vm.contentData.headline || '',
      "push_type": _vm.push_type,
      "cover": _vm.cover,
      "source": _vm.source,
      "push_content": _vm.contentData && _vm.contentData.content || ''
    },
    on: {
      "jump-url": _vm.jumpUrl
    }
  }) : _c('div', {
    staticClass: "content-wrap-push",
    class: {
      'closed-style': _vm.showMore
    }
  }, [_vm.contentData.headline && _vm.contentData.content ? _c('div', {
    staticClass: "content-text",
    class: {
      'forewarning-content': _vm.isForewarning
    }
  }, [_c('div', {
    staticClass: "content-text-title"
  }, [_vm._v(" " + _vm._s(_vm.contentData.headline) + " ")]), _c('div', {
    ref: "pushTextContent",
    staticClass: "content-text-detail",
    style: _vm.heightStyle,
    domProps: {
      "innerHTML": _vm._s(_vm.contentData.content)
    }
  })]) : _vm._e(), _vm.showMore ? _c('div', {
    staticClass: "open-more",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.handleOpen.apply(null, arguments);
      },
      "touchstart": function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "open-btn"
  }, [_c('div', {
    staticClass: "open-text"
  }, [_vm._v(_vm._s('查看全文'))]), _c('div', {
    staticClass: "open-icon"
  })])]) : _vm._e()]), (_vm$pushData = _vm.pushData) !== null && _vm$pushData !== void 0 && (_vm$pushData = _vm$pushData.mentioned) !== null && _vm$pushData !== void 0 && _vm$pushData.content && !_vm.isHarmony ? _c('poiLine', {
    staticClass: "poi-line-new",
    attrs: {
      "feed-item": _vm.pushData,
      "poi-list": (_vm$pushData2 = _vm.pushData) === null || _vm$pushData2 === void 0 || (_vm$pushData2 = _vm$pushData2.mentioned) === null || _vm$pushData2 === void 0 ? void 0 : _vm$pushData2.content,
      "data-index": _vm.pushIndex,
      "unique_id": _vm.pushData.unique_id
    },
    on: {
      "open-Baidu-Map": _vm.jumpToMap
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };